import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer, {LineStyle} from 'ui-library/reactflow/edges/BaseEdgeRenderer';

export default function TaskSchemaDataFlowEdge(props: EdgeProps): JSX.Element {
  return <BaseEdgeRenderer {...props} data={{...(props.data ?? {}), lineStyle: LineStyle.DASHED}} />;
}
